import { useRequest } from "@/shared/composables/useRequest.ts";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService.ts";
import { NotificationsRepository } from "@/app/header/notifications/repositories/NotificationsRepository";
import { NotificationsFilterModel } from "@/app/header/notifications/models/NotificationsFilterModel";
import { NotificationsPaginatedModel } from "@/app/header/notifications/models/NotificationsModel";

export function getAllPaginatedNotificationsController() {
  const repository: NotificationsRepository = new NotificationsRepository(new HttpClientService());

  return useRequest<NotificationsPaginatedModel>({
    fn: async (userId: string | number, filter: NotificationsFilterModel) =>
      await repository.getAllPaginatedNotifications(userId, filter),
    modelClass: NotificationsPaginatedModel,
  });
}
